import { Component } from '@angular/core';
import { GenericLinkComponent, IconComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-efa-header-telephone',
    templateUrl: 'header-telephone.component.html',
    imports: [GenericLinkComponent, IconComponent]
})
export class HeaderTelephoneComponent {}
